export default __webpack_public_path__ + "static/media/140.3adc3f91.jpg";